/**
 * Конфиг зубных групп
 */
const teethGroups = {
  all: {
    teeth: [11, 12, 13, 14, 15, 16, 17, 18, 21, 22, 23, 24, 25, 26, 27, 28,
      31, 32, 33, 34, 35, 36, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48],
    text: 'Все зубы',
  },
  upperJaw: {
    teeth: [11, 12, 13, 14, 15, 16, 17, 18, 21, 22, 23, 24, 25, 26, 27, 28],
    text: 'В/Ч',
  },
  lowerJaw: {
    teeth: [31, 32, 33, 34, 35, 36, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48],
    text: 'Н/Ч',
  },
  allMilk: {
    teeth: [51, 52, 53, 54, 55, 61, 62, 63, 64, 65, 71, 72, 73, 74, 75, 81, 82, 83, 84, 85],
    text: 'Все зубы (молочный прикус)',
  },
  upperJawMilk: {
    teeth: [51, 52, 53, 54, 55, 61, 62, 63, 64, 65],
    text: 'В/Ч (молочный прикус)',
  },
  lowerJawMilk: {
    teeth: [71, 72, 73, 74, 75, 81, 82, 83, 84, 85],
    text: 'Н/Ч (молочный прикус)',
  },
};

/**
 * @description Среди массива зубов целиком есть группа
 * @param {Array} group группа зубов
 * @param {Array} teeth массив зубов
 * @return {boolean}
 */
const allTeethContainsAtGroup = (group, teeth) => {
  teeth.forEach((toothNumber) => {
    const index = group.indexOf(toothNumber);
    if (index !== -1) {
      group.splice(index, 1);
    }
  });
  return group.length === 0;
};

/**
 * Удалить из массива зубов вхождения группы и вернуть новый
 * @param {Array} group группа зубов
 * @param {Array} teeth массив зубов
 * @return {Array}
 */
const removeTeethNumberContainsGroup = (group, teeth) => {
  group.forEach((toothNumber) => {
    const index = teeth.indexOf(toothNumber);
    if (index !== -1) {
      teeth.splice(index, 1);
    }
  });
  return teeth;
};

export default {
  methods: {
    groupTeethInSegments(teeth) {
      let teethNumberArray = [...teeth];
      const teethGroupText = [];
      let teethText = '';
      Object.values(teethGroups).forEach((group) => {
        if (allTeethContainsAtGroup([...group.teeth], teethNumberArray)) {
          teethNumberArray = removeTeethNumberContainsGroup(
            group.teeth,
            teethNumberArray,
          );
          teethGroupText.push(group.text);
        }
      });
      if (teethGroupText.length) {
        teethText = teethGroupText.concat(teethNumberArray).join(', ');
      } else {
        teethText = teethNumberArray.join(', ');
      }
      return teethText;
    },
  },
};
